import { normalizeDateToYyyyMmDd } from "../SafetyObservation/observationUtils";

export const INITIAL_MEETING_FORM_DATA = {
  title: "",
  date: "",
  location: "",
  agenda: "",
  minutes: "",
  attendee_ids: [],
};

export const formatDateForInput = (dateValue) =>
  normalizeDateToYyyyMmDd(dateValue);

export const buildMeetingFormData = (formData, attachments = []) => {
  const payload = new FormData();

  payload.append("title", formData.title.trim());
  payload.append("date", normalizeDateToYyyyMmDd(formData.date));
  payload.append("location", formData.location.trim());
  payload.append("agenda", formData.agenda.trim());
  payload.append("minutes", formData.minutes.trim());
  payload.append("attendee_ids", JSON.stringify(formData.attendee_ids || []));

  attachments.forEach((attachment) => {
    if (attachment instanceof File) {
      payload.append("attachments", attachment);
    }
  });

  return payload;
};

export const isExistingMeetingAttachment = (attachment) =>
  Boolean(attachment?.id);

export const getMeetingAttachmentName = (attachment) =>
  attachment?.filename || attachment?.name || "Attachment";

export const getMeetingAttachmentSizeLabel = (attachment) => {
  if (attachment instanceof File) {
    return `${(attachment.size / 1024).toFixed(2)} KB`;
  }

  const numericSize = Number(attachment?.file_size);
  if (!Number.isNaN(numericSize) && numericSize > 0) {
    return `${numericSize.toFixed(2)} KB`;
  }

  if (typeof attachment?.file_size === "string" && attachment.file_size.trim()) {
    return attachment.file_size;
  }

  return "Size unavailable";
};

export const getMeetingAgendaPreview = (value, maxLength = 60) => {
  if (!value) return "NA";
  if (value.length <= maxLength) return value;
  return `${value.slice(0, maxLength)}...`;
};
